
import SportIcon from './sport-icon'

export default
    name: 'event-row'
    components: {SportIcon}
    props:
        event:
            type: Object
            required: true
        dateLabel:
            type: String
            default: null
        current:
            type: Boolean
            default: false
    computed:
        live: ->
            @event.races.some((race) -> race.live)
